<template>
  <div class="content-confirm">
    <AppHeader title="上机确认"/>
    <div class="booking-inf" v-if="booking">
      <div class="eq-title">{{ booking.equipment.name }}</div>
      <div class="eq-img" v-if="booking.equipment.avatar"><img :src="`${this.imgUrl}/${booking.equipment.avatar}`" class="eq-img" /></div>
      <div class="eq-img" v-else>没有图片</div>
      <div class="booking-desc">
        <div class="booking-desc-line"><span>存放地点: </span>{{ booking.equipment.eqLocation }}</div>
        <div class="booking-desc-line" v-if="booking.equipment && booking.equipment.bookingType === 'BOOKING'"><span>预约时间: </span>{{ beginEnd(booking.beginAt, booking.endAt)}}</div>
        <div class="booking-desc-line"><span>当前时间: </span>{{ this.$moment().format('YYYY.MM.DD HH:mm') }}</div>
        <div class="booking-desc-line"><span>当前状态: </span><span class="eq-status" :class="equipmentStatusClass">{{ equipmentStatusText }}</span></div>
      </div>
    </div>
    <div class="content">
      <div class="btn green"  @click="registBiz()" v-if="blueToothTypeShow ">蓝牙上机</div>
      <div class="btn green" @click="startExp" v-if="!blueToothTypeShow">确认上机</div>
    </div>

    <div class="overlay" v-if="loadFlag">
      <div class="tooltip"> 数据加载中...</div>
    </div>

    <!-- 强制下机确认对话框 -->
    <div class="force-end-overlay" v-if="showForceEndDialog">
      <div class="force-end-dialog">
        <div class="dialog-header">
          <i class="mint-icon mint-icon-info"></i>
          <div class="dialog-title">设备被占用</div>
        </div>

        <div class="dialog-content">
          <div class="info-item">
            <span class="info-label">实验状态：</span>
            <span class="info-value">已运行 {{ forceEndData.timeInfo }}</span>
          </div>

          <div class="info-item" v-if="forceEndData.bookingEndTime">
            <span class="info-label">预约结束：</span>
            <span class="info-value">{{ forceEndData.bookingEndTime }}</span>
          </div>

          <div class="warning-text">
            影响到您的当前实验
          </div>

          <div class="contact-card">
            <div class="contact-title">请联系前序用户</div>
            <div class="contact-row">
              <span class="contact-label">姓名：</span>
              <span class="contact-value">{{ forceEndData.userName }}</span>
            </div>
            <div class="contact-row">
              <span class="contact-label">电话：</span>
              <span class="contact-value">{{ forceEndData.userMobile }}</span>
              <a :href="`tel:${forceEndData.userMobile}`" class="call-btn">
                <i class="mint-icon mint-icon-phone"></i> 拨打
              </a>
            </div>
          </div>

          <div class="tip-text">
            如联系后确认可以结束，可进行强制下机处理
          </div>
        </div>

        <div class="dialog-actions">
          <button class="btn btn-cancel" @click="cancelForceEnd">取消</button>
          <button class="btn btn-danger" @click="confirmForceEnd">强制下机</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>

.force-end-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
}

.force-end-dialog {
  background: white;
  border-radius: 8px;
  width: 100%;
  max-width: 400px;
  max-height: 90vh;
  overflow-y: auto;
}

.dialog-header {
  text-align: center;
  padding: 20px 20px 15px;
  border-bottom: 1px solid #E6E6E6;

  .mint-icon {
    font-size: 50px;
    color: #F86719;
    margin-bottom: 10px;
  }

  .dialog-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
  }
}

.dialog-content {
  padding: 20px;
}

.info-item {
  margin-bottom: 12px;
  font-size: 15px;
  display: flex;
  align-items: center;

  .info-label {
    font-weight: bold;
    color: #333;
    min-width: 80px;
  }

  .info-value {
    color: #666;
    flex: 1;
  }
}

.warning-text {
  margin: 15px 0;
  padding: 10px;
  background: #FFF3E0;
  border-left: 3px solid #F86719;
  color: #F86719;
  font-size: 14px;
  font-weight: bold;
}

.contact-card {
  background: #F5F7FA;
  border-radius: 4px;
  padding: 15px;
  margin: 15px 0;

  .contact-title {
    font-size: 14px;
    font-weight: bold;
    color: #333;
    margin-bottom: 10px;
  }

  .contact-row {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    font-size: 15px;

    &:last-child {
      margin-bottom: 0;
    }

    .contact-label {
      font-weight: bold;
      color: #333;
      min-width: 50px;
    }

    .contact-value {
      flex: 1;
      color: #666;
    }

    .call-btn {
      display: inline-flex;
      align-items: center;
      padding: 5px 12px;
      background: #409EFF;
      color: white;
      border-radius: 4px;
      text-decoration: none;
      font-size: 13px;
      margin-left: 10px;

      .mint-icon {
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }
}

.tip-text {
  font-size: 13px;
  color: #999;
  line-height: 1.5;
  text-align: center;
}

.dialog-actions {
  padding: 15px 20px;
  border-top: 1px solid #E6E6E6;
  display: flex;
  gap: 15px;

  .btn {
    flex: 1;
    height: 45px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    font-weight: bold;
    cursor: pointer;
  }

  .btn-cancel {
    background: #ccc;
    color: #666;
  }

  .btn-danger {
    background: #F56C6C;
    color: white;
  }
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明黑色 */
  z-index: 10; /* 确保遮罩层在内容上方 */
  display: flex; /* 使用 Flexbox */
  justify-content: center; /* 水平居中 */
  align-items: center; /* 垂直居中 */

}
.tooltip {
  background-color: white;
  padding: 15px;
  border-radius: 5px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3); /* 阴影 */
}

.eq-status {
  font-size: 15px;
  font-weight: normal;
}

/* 待机中 - 蓝色 */
.eq-status.status-standby {
  color: #4A89DC !important;
}

/* 使用中 - 橙色 */
.eq-status.status-in-use {
  color: #F86719 !important;
}

/* 实验中 - 绿色 */
.eq-status.status-experimenting {
  color: #8FD918 !important;
}

.booking-desc {
  margin-top: 20px;
  width: 100%;
}

.booking-inf {
  padding: 15px 20px;
  background: #fff;
  border-radius: 5px;
  margin: 50px 20px 20px;
  display: flex;
  align-items: center;
  flex-direction: column;
}

.content-confirm {
  margin: 0;
  background: linear-gradient(#31B8D3, #1682A7);
}

.eq-title {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  color: #333333;
}

.eq-img {
  width: 240px;
  height: 240px;
  line-height: 240px;
  align-self: center;
  border-radius: 5px;
  border: 1px solid #E6E6E6;
  background: RGBA(67, 74, 84, .9);
  color: #fff;
  text-align: center;
  font-size: 16px;
}

.booking-desc-line {
  font-size: 15px;
  color: #666;
  display: flex;
  align-items: center;
  margin-top: 10px;
  span {
    font-weight: bold;
    color: #333;
    padding-right: 5px;
  }

  &:first-child{
    margin-top: 0;
  }
}
</style>
<script>
import AppHeader from "@/components/AppHeader";
import {Toast} from 'mint-ui';
import store from "@/plugins/store";
import wx from 'weixin-js-sdk';

export default {
  components: {
    AppHeader
  },
  data() {
    return {
      booking: null,
      equipment: null,
      blueToothTypeShow:false,
      endFlag: false,
      loadFlag: false,
      showForceEndDialog: false,
      forceEndData: {
        experimentId: null,
        eqcode: null,
        userName: '',
        userMobile: '',
        timeInfo: '',
        bookingEndTime: '',
        isFromBluetooth: false
      },
      // 设备状态：standby-待机中, inUse-使用中, experimenting-实验中
      equipmentStatus: 'standby'
    }
  },
  computed: {
    // 设备状态显示文本
    equipmentStatusText() {
      switch (this.equipmentStatus) {
        case 'inUse':
          return '使用中'
        case 'experimenting':
          return '实验中'
        case 'standby':
        default:
          return '待机中'
      }
    },
    // 设备状态样式类
    equipmentStatusClass() {
      switch (this.equipmentStatus) {
        case 'inUse':
          return 'status-in-use'
        case 'experimenting':
          return 'status-experimenting'
        case 'standby':
        default:
          return 'status-standby'
      }
    }
  },
  methods: {
    /**
     * 取消强制下机对话框
     */
    cancelForceEnd() {
      this.showForceEndDialog = false;
    },

    /**
     * 确认强制下机
     */
    confirmForceEnd() {
      this.showForceEndDialog = false;
      if (this.forceEndData.isFromBluetooth) {
        this.forceEndExperimentForBluetooth(this.forceEndData.experimentId, this.forceEndData.eqcode);
      } else {
        this.forceEndExperiment(this.forceEndData.experimentId, this.forceEndData.eqcode);
      }
    },

    beginEnd(beginAt, endAt) {
      let beginYMD = this.$moment(beginAt).format('YYYY.MM.DD')
      let result = this.$moment(beginAt).format('YYYY.MM.DD HH:mm')
      if (endAt) {
        let endYMD = this.$moment(endAt).format('YYYY.MM.DD')
        if (endYMD == beginYMD) {
          result += ("-" + this.$moment(endAt).format('HH:mm'))
        } else {
          result += ("-" + this.$moment(endAt).format('YYYY.MM.DD HH:mm'))
        }
      } else {
        result += "-"
      }
      return result
    },
    /**
     * 开始实验 - 先检查设备状态
     */
    async startExp(){
      console.log('====== 点击确认上机 ======');
      const that = this
      var eqId = that.$route.query.equipmentId

      console.log('equipmentId:', eqId);
      console.log('booking对象:', this.booking);

      if (!this.booking || !this.booking.equipment) {
        Toast('预约信息错误');
        console.error('booking对象为空或缺少equipment');
        return;
      }

      const equipment = this.booking.equipment;
      console.log('equipment:', equipment);

      // 先调用 checkEquipmentStatus 检查设备状态
      try {
        console.log('调用 checkEquipmentStatus 检查设备状态...');
        const checkRes = await this.$http.get('/api/experiment/checkEquipmentStatus', {
          params: {
            eqcode: equipment.code
          }
        });

        console.log('checkEquipmentStatus 返回结果:', checkRes);

        if (!checkRes.success) {
          Toast(checkRes.msg || '检查失败');
          return;
        }

        const statusData = checkRes.data;
        console.log('设备状态:', statusData);

        // 如果设备有实验正在进行且可以强制下机
        if (statusData.hasExperiment && statusData.canForceEnd) {
          console.log('设备被占用且满足强制下机条件，显示强制下机确认对话框');

          // 构建时间信息
          const hours = statusData.hoursRunning || 0;
          const minutes = statusData.minutesRunning || 0;
          const timeInfo = hours > 0 ? `${hours}小时${minutes}分钟` : `${minutes}分钟`;

          // 填充强制下机数据并显示自定义对话框
          this.forceEndData = {
            experimentId: statusData.experimentId,
            eqcode: equipment.code,
            userName: statusData.userName,
            userMobile: statusData.userMobile,
            timeInfo: timeInfo,
            bookingEndTime: statusData.booking && statusData.booking.endAt ?
              that.$moment(statusData.booking.endAt).format('YYYY-MM-DD HH:mm') : '',
            isFromBluetooth: false
          };
          this.showForceEndDialog = true;
          return;
        }

        // 如果设备有实验正在进行但不满足强制下机条件
        if (statusData.hasExperiment && !statusData.canForceEnd) {
          console.log('设备被占用但不满足强制下机条件:', statusData.message);
          Toast(statusData.message || '设备正在使用中，暂时无法上机');
          return;
        }

        // 设备空闲，继续确认上机流程
        console.log('设备空闲，继续确认上机流程');
      } catch (error) {
        console.error('checkEquipmentStatus 调用失败', error);
        Toast('网络请求失败');
        return;
      }

      // 开始确认上机流程
      console.log('调用 smartToggleExam 开始实验...');
      try {
        const res = await this.$http.get('/api/experiment/smartToggleExam', {
          params: {
            eqcode: equipment.code,
            operationByUser: true,
            finalAccounts: false,
            withoutHeartbeat: true
          }
        });

        console.log('smartToggleExam 返回结果:', res);

        // 检查是否需要超时确认
        if (res.success && res.data && res.data.needConfirm) {
          console.log('需要超时确认，跳转到超时确认页面');
          that.$router.push({
            path: '/timeout-confirm',
            query: {
              equipmentId: eqId,
              eqcode: equipment.code,
              previousExperimentId: res.data.previousExperimentId,
              previousUserName: res.data.previousUserName,
              previousUserMobile: res.data.previousUserMobile,
              message: res.data.message,
              isAdmin: res.data.isAdmin
            }
          });
        } else if (res.success && res.data && res.data.experimentId) {
          Toast(res.data.user || '上机成功');
          that.$router.push({
            path: '/exp',
            query: {
              equipmentId: eqId,
              bookingId: res.data.experimentId
            }
          });
        } else {
          Toast(res.msg || '操作失败');
        }
      } catch (error) {
        console.error('smartToggleExam 调用失败', error);
        Toast('网络请求失败');
      }
    },

    /**
     * 强制结束前序实验（确认上机）
     */
    async forceEndExperiment(experimentId, eqcode) {
      const that = this;
      console.log('调用强制结束实验接口，experimentId:', experimentId);

      try {
        const res = await this.$http.post('/api/experiment/forceEndExperiment', null, {
          params: {
            experimentId: experimentId,
            eqcode: eqcode
          }
        });

        console.log('forceEndExperiment 返回结果:', res);

        if (res.success) {
          Toast({
            message: '前序实验已被终止，您可以继续实验了',
            duration: 2000
          });

          // 等待提示显示后，自动调用上机
          setTimeout(() => {
            that.startExp();
          }, 2000);
        } else {
          // 如果是"实验已结束"错误，直接尝试上机
          if (res.msg && res.msg.includes('实验已结束')) {
            Toast({
              message: '前序实验已结束，正在为您上机...',
              duration: 1500
            });
            setTimeout(() => {
              that.startExp();
            }, 1500);
          } else {
            Toast(res.msg || '强制下机失败');
          }
        }
      } catch (error) {
        console.error('强制下机失败', error);
        Toast('网络请求失败');
      }
    },

    /**
     * 强制结束前序实验（蓝牙上机）
     */
    async forceEndExperimentForBluetooth(experimentId, eqcode) {
      const that = this;
      console.log('蓝牙上机 - 调用强制结束实验接口，experimentId:', experimentId);

      try {
        const res = await this.$http.post('/api/experiment/forceEndExperiment', null, {
          params: {
            experimentId: experimentId,
            eqcode: eqcode
          }
        });

        console.log('forceEndExperiment 返回结果:', res);

        if (res.success) {
          Toast({
            message: '前序实验已被终止，您可以继续实验了',
            duration: 2000
          });

          // 等待提示显示后，自动调用蓝牙上机
          setTimeout(() => {
            that.registBiz();
          }, 2000);
        } else {
          // 如果是"实验已结束"错误，直接尝试蓝牙上机
          if (res.msg && res.msg.includes('实验已结束')) {
            Toast({
              message: '前序实验已结束，正在为您上机...',
              duration: 1500
            });
            setTimeout(() => {
              that.registBiz();
            }, 1500);
          } else {
            Toast(res.msg || '强制下机失败');
          }
        }
      } catch (error) {
        console.error('强制下机失败', error);
        Toast('网络请求失败');
      }
    },
    /**
     * 蓝牙上机流程 - 先检查设备状态
     */
    async registBiz() {
      console.log('====== 点击蓝牙上机 ======');
      const that = this
      const eqId = that.$route.query.equipmentId

      console.log('equipmentId:', eqId);
      console.log('booking对象:', this.booking);

      if (!this.booking || !this.booking.equipment) {
        Toast('预约信息错误');
        console.error('booking对象为空或缺少equipment');
        return;
      }

      const equipment = this.booking.equipment;

      // 先调用 checkEquipmentStatus 检查设备状态
      try {
        console.log('蓝牙上机前调用 checkEquipmentStatus 检查设备状态...');
        const checkRes = await this.$http.get('/api/experiment/checkEquipmentStatus', {
          params: {
            eqcode: equipment.code
          }
        });

        console.log('checkEquipmentStatus 返回结果:', checkRes);

        if (!checkRes.success) {
          Toast(checkRes.msg || '检查失败');
          return;
        }

        const statusData = checkRes.data;
        console.log('设备状态:', statusData);

        // 如果设备有实验正在进行且可以强制下机
        if (statusData.hasExperiment && statusData.canForceEnd) {
          console.log('设备被占用且满足强制下机条件，显示强制下机确认对话框');

          // 构建时间信息
          const hours = statusData.hoursRunning || 0;
          const minutes = statusData.minutesRunning || 0;
          const timeInfo = hours > 0 ? `${hours}小时${minutes}分钟` : `${minutes}分钟`;

          // 填充强制下机数据并显示自定义对话框
          this.forceEndData = {
            experimentId: statusData.experimentId,
            eqcode: equipment.code,
            userName: statusData.userName,
            userMobile: statusData.userMobile,
            timeInfo: timeInfo,
            bookingEndTime: statusData.booking && statusData.booking.endAt ?
              that.$moment(statusData.booking.endAt).format('YYYY-MM-DD HH:mm') : '',
            isFromBluetooth: true
          };
          this.showForceEndDialog = true;
          return;
        }

        // 如果设备有实验正在进行但不满足强制下机条件
        if (statusData.hasExperiment && !statusData.canForceEnd) {
          console.log('设备被占用但不满足强制下机条件:', statusData.message);
          Toast(statusData.message || '设备正在使用中，暂时无法上机');
          return;
        }

        // 设备空闲，继续蓝牙上机流程
        console.log('设备空闲，继续蓝牙上机流程');
      } catch (error) {
        console.error('checkEquipmentStatus 调用失败', error);
        Toast('网络请求失败');
        return;
      }

      // 开始蓝牙上机流程
      console.log('开始蓝牙上机流程');
      const fullPath = encodeURIComponent(that.$route.fullPath)

      // 判断是否为随到随上模式
      var isNoBooking = this.$route.query.isNoBooking
      var regisBizUrl = '/api/booking/regisBiz?equipmentId='+eqId+"&bizOperator=open&fullPath="+fullPath
      if(isNoBooking && isNoBooking === 'true'){
        // 随到随上模式，使用设备code
        regisBizUrl += "&code=" + this.booking.equipment.code
        console.log('随到随上模式，使用设备code:', this.booking.equipment.code);
      } else {
        // 有预约模式，使用bookingId
        regisBizUrl += "&bookingId=" + this.booking.id
        console.log('预约模式，使用bookingId:', this.booking.id);
      }

      console.log('调用 /api/booking/regisBiz 接口...');
      this.$http.get(regisBizUrl).then(res =>{
        console.log('regisBiz 返回结果:', res);
        if (res.success && res.data && res.data.scheme){
          console.log('接口调用成功，开始蓝牙流程');
          that.scheme=res.data.scheme
          let bizId=res.data.bizId
          that.getBizStatus(bizId);

          // 启动微信小程序
          const ua = window.navigator.userAgent.toLowerCase();
          if (ua.match(/micromessenger/i)) {
            wx.miniProgram.getEnv((res) => {
              if (res.miniprogram) {
                console.log("小程序环境下逻辑")
                let bizCode=that.scheme.substring(that.scheme.indexOf("id%3D")+5)
                console.log("bizCode",bizCode)
                wx.miniProgram.navigateTo({
                  url: '/pages/index/index?id='+bizCode
                });
              } else {
                console.log("非小程序环境下逻辑")
                window.location.href= that.scheme
              }
            });
          } else {
            console.log("非微信环境下")
            window.location.href= that.scheme
          }

          // 开始轮询蓝牙状态
          let count=0;
          let timer=setInterval(()=>{
            that.getBizLastStatus(bizId, eqId);
            count++;
            this.loadFlag=true
            if (that.endFlag || count>10){
              clearInterval(timer)
              this.loadFlag=false
              if (count>10){
                setTimeout(()=>{
                  Toast('抱歉，蓝牙连接失败，请检查微信位置、微信附近的设备和蓝牙是否开启。确认开启后，请重新扫码或尝试其他设备');
                },1000)
              }
            }
          }, 3000);
        } else {
          console.error('regisBiz接口返回失败:', res);
          Toast(res.msg || '蓝牙上机失败');
        }
      }).catch(error => {
        console.error('regisBiz接口调用异常:', error);
        Toast('网络请求失败');
      })
    },

    /**
     * 轮询检查蓝牙操作状态
     * 蓝牙成功后直接跳转到实验页面，不再调用 startExp()
     */
    getBizLastStatus(bizId, equipmentId){
      if (!this.endFlag){
        const that = this;
        this.$http.get('/api/booking/getBizLastStatus?bizId='+bizId+'&bizOperator=open').then(response =>{
          if(response.success && response.data.machineLastState=='1'){
            // 蓝牙开机成功
            this.endFlag=true

            // 直接跳转到实验页面，不再调用 startExp()
            // 因为蓝牙服务已经通过后端完成了开机操作
            that.$router.push({
              path: '/exp',
              query: {
                equipmentId: equipmentId,
                bookingId: that.booking.id,
                isBlueTh: true  // 标记这是蓝牙上机
              }
            });
          }
        })
      }
    },
    getBizStatus(bizId){
      var isnoBooking= this.$route.query.isNoBooking
      var urls='/api/booking/getBizStatus?bizId='+bizId+"&bizOperator=open&bookingId="+this.booking.id
      if(isnoBooking && isnoBooking==='true'){
        urls='/api/booking/getBizStatus?bizId='+bizId+"&bizOperator=open&code="+this.booking.equipment.code
      }
      this.$http.post(urls).then(() =>{})
    },
    /**
     * 查询设备当前状态
     * 待机中：设备空闲
     * 使用中：设备被其他用户占用
     * 实验中：当前用户自己有进行中的实验
     */
    async checkEquipmentCurrentStatus() {
      if (!this.booking || !this.booking.equipment) {
        return
      }
      try {
        const res = await this.$http.get('/api/experiment/checkEquipmentStatus', {
          params: {
            eqcode: this.booking.equipment.code
          }
        })
        if (res.success && res.data) {
          const statusData = res.data
          if (statusData.hasExperiment) {
            // 设备有实验正在进行
            if (statusData.isCurrentUser) {
              // 是当前用户的实验
              this.equipmentStatus = 'experimenting'
            } else {
              // 是其他用户的实验
              this.equipmentStatus = 'inUse'
            }
          } else {
            // 设备空闲
            this.equipmentStatus = 'standby'
          }
        }
      } catch (error) {
        console.error('查询设备状态失败:', error)
        // 查询失败时默认显示待机中
        this.equipmentStatus = 'standby'
      }
    },
  },
  mounted() {
    console.log('====== confirm页面 mounted ======');
    console.log('路由参数:', this.$route.query);

    // var isNoBooking= this.$route.query.isNoBooking
    // if(isNoBooking){
    //   this.equipment = this.$route.query.equipment
    //   console.log("equipment",this.equipment)
    // }else {
      this.booking = store.getters.curBooking
      console.log("从store获取的booking:", this.booking)

    if (this.booking== null){
      console.warn('⚠️ booking为空，检查跳转逻辑');
      console.log("equipmentId",this.$route.query.equipmentId)
      console.log("isBlueTh",this.$route.query.isBlueTh)
      console.log("bookingId",this.$route.query.bookingId)
      if (this.$route.query.equipmentId && this.$route.query.isBlueTh && this.$route.query.bookingId){
        this.$router.push({
          path: '/exp',
          query: {
            equipmentId: this.$route.query.equipmentId,
            bookingId: this.$route.query.bookingId
          }
        })
      }else {
        this.$router.push("/")
      }

    }
    // }

    if (this.booking && this.booking.equipment && this.booking.equipment.blueToothId){
      console.log('设备有蓝牙ID，显示蓝牙上机按钮');
      this.blueToothTypeShow=true
    } else {
      console.log('设备无蓝牙ID或booking为空，不显示蓝牙上机按钮');
    }

    console.log('blueToothTypeShow:', this.blueToothTypeShow);

    // 查询设备当前状态
    this.checkEquipmentCurrentStatus()
  }
}
</script>
